var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.distributorCreatable
    ? _c(
        "v-menu",
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function (ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "round-button",
                      _vm._g(
                        _vm._b(
                          {
                            attrs: {
                              icon: "add_circle",
                              "data-testid": "create-account",
                            },
                          },
                          "round-button",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.$t("button.add_account")) +
                            "\n      "
                        ),
                        _c("span", { staticClass: "ml-1" }, [_vm._v("▼")]),
                      ]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            449840805
          ),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                { attrs: { to: "/admin/accounts/new" } },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("menu.account"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                { attrs: { to: "/admin/accounts/new?type=distributor" } },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("menu.distributor_account"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "round-button",
        {
          attrs: {
            icon: "add_circle",
            to: "/admin/accounts/new",
            "data-testid": "create-account",
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.$t("button.add_account")) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }